import React from 'react';
import { PrivyProvider } from '@privy-io/react-auth';
import AuthComponent from './components/AuthComponent';
import './App.css';

function App() {
  return (
    <PrivyProvider
      appId={import.meta.env.VITE_PRIVY_APP_ID || 'your-privy-app-id'}
      config={{
        appearance: {
          theme: 'light',
        },
        embeddedWallets: {
          createOnLogin: 'users-without-wallets',
        },
      }}
    >
      <AuthComponent />
    </PrivyProvider>
  );
}

export default App;
